<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Prodotti venduti</p>
                    <v-spacer></v-spacer>
                </v-card-title>
				<v-divider></v-divider>
				<v-container class="pa-0 px-2 mt-4" fluid>
					<v-row class="pa-4">
						<v-col class="py-0" cols="3">
							<gmh-date-picker
								v-model="model['from']"
								label="Da"
								:clearable="false"
							></gmh-date-picker>
						</v-col>

						<v-col class="py-0" cols="3">
							<gmh-date-picker
								v-model="model['to']"
								label="A"
								:min="model['from']"
								:clearable="false"
							></gmh-date-picker>
						</v-col>							
						<v-col class="py-0" cols="12" >
							<v-autocomplete
								:items="fieldsset.companycategories.options"
								label="Categorie aziende"
								v-model="model['category_id']"
								clearable
								small-chips
								multiple
								dense
								outlined
							></v-autocomplete>
						</v-col>							
						<v-col class="py-0" cols="12" >
							<v-autocomplete
								:items="fieldsset.companies.options"
								label="Aziende"
								v-model="model['company_id']"
								clearable
								small-chips
								disable-initial-sort
								multiple
								dense
								outlined
							></v-autocomplete>
						</v-col>							
						<v-col class="py-0" cols="12" >
							<v-autocomplete
								:items="fieldsset.products.options"
								label="Prodotti"
								v-model="model['product_id']"
								clearable
								small-chips
								disable-initial-sort
								multiple
								dense
								outlined
							></v-autocomplete>
						</v-col>
					</v-row>
					<v-data-table
						class="background-2"
						:items="items"
						:headers="headers"
						show-select
						v-model="selected"
						:mobile-breakpoint="0"
						:footer-props="{
							'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
						}"
						>
						<template v-slot:header.data-table-select="{ on, props }">
							<v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
						</template>
						<template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
							<tr class="cursor-pointer">
								<template v-for="(header, h) in headers">
									<td :key="h" v-if="header.value == 'data-table-select'">
										<v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
									</td>
									<td v-else-if="header.type === 'date'" :key="item[header.value]">
										<div v-ripple>
											{{ item[header.value] | date }}
										</div>
									</td>
									<td v-else :key="item[header.value]">
										{{ item[header.value] }}							  
									</td>
								</template>
							</tr>
						</template>
					</v-data-table>
				</v-container>
			</v-card>
			<v-speed-dial
				v-model="fab"
				absolute
				bottom
				right
				direction="left"
				transition="scale-transition">
				<template v-slot:activator>
					<v-btn
						color="primary"
						dark
						fab
						v-model="fab">
						<v-icon v-if="fab">close</v-icon>
						<v-icon v-else>local_offer</v-icon>
					</v-btn>      
				</template> 
				<v-tooltip top>
					<template v-slot:activator="{ on: tooltip }">
						<v-btn
							v-on="{ ...tooltip }"
							fab
							dark
							small
							color="green"
							@click.native.stop="$eventBusUtility.exportCSV(headers, selected, 'scadenze_prodotti')">
							<v-icon>play_for_work</v-icon>
						</v-btn>
					</template>
					<span>Esporta CSV</span>
				</v-tooltip>                            
			</v-speed-dial>
		</v-col>
	</v-row>
</template>

<script>

	export default {
		name: "expiration-products",
		props: {

		},
		data() {
			return {
				fieldsset: {},
				model: {},
				headers: [],
				loaded: false,
				items: [],
				fab: false,
				selected: [],
			}
		},

		created() {
			this.axios.get('marbecexpirationproducts-info').then(response => {
				// get body data
				this.fieldsset = response.data.info.fields
				this.headers = response.data.info.headers

				_.forEach(this.fieldsset, (value, key) => {
					if(value.default) {
						Vue.set(this.model, value.key, value.default)
					}
				})

				this.$store.commit('endProgress')

			}, response => {
				// error callback
			});
		},

		watch: {
			model: {
				handler() {
					this.getData()
				},
				deep: true,
			},

			selected: {
			    handler() {
			        this.selected.length > 0 ? this.disabled = false : this.disabled = true
			    }
			}
		},

		methods: {

			getData() {

				this.axios.post('marbecexpirationproducts', this.model).then(response => {
					this.items = response.data.data

				}, response => {
					// error callback
				});
			},

			toggleAll () {
			    if (this.selected.length) {
			        this.selected = []   
			    } else { 
			        this.selected = this.items.slice()
			    }
			},
		},
	}
</script>